import { render, staticRenderFns } from "./planDeeplink.vue?vue&type=template&id=059a9e54&"
import script from "./planDeeplink.vue?vue&type=script&lang=js&"
export * from "./planDeeplink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports